import { render } from "./ModerationList.vue?vue&type=template&id=05233da6&ts=true&lang=pug"
import script from "./ModerationList.vue?vue&type=script&lang=ts"
export * from "./ModerationList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__